function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2019, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */
import React, { Component } from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import { Add, WarningAlt } from "@carbon/react/icons";
import { Button, Checkbox, Modal } from "@carbon/react";
import { IntlProvider, FormattedHTMLMessage } from "react-intl";
import SecretDialogFields from "../common/SecretDialogFields";
import { format } from "../../utils/locales";
import vaultUtil from "../../utils/vault-util";
var keyTypeText = {
  "api-key": {
    modalHeading: "createAPIKeyTitle",
    buttonTooptip: "buttonCreateTooltip",
    defaultName: "defaultApiKeyName",
    modalDescription: "createAPIKeyFullDescription",
    descriptionLabel: "newKeyDescription"
  },
  "service-id": {
    modalHeading: "createServiceIDTitle",
    buttonTooptip: "buttonCreateServiceIDTooltip",
    defaultName: "defaultServiceIDName",
    modalDescription: "createServiceIDDescription",
    descriptionLabel: "newKeyDescription"
  },
  "gpg-key": {
    modalHeading: "createGPGKeyTitle",
    buttonTooptip: "buttonCreateGPGKeyTooltip",
    defaultName: null,
    modalDescription: "createGPGKeyDescription",
    descriptionLabel: "createGPGKeyEmail"
  }
};
var SecretMintingDialog = /*#__PURE__*/function (_Component) {
  function SecretMintingDialog(props) {
    var _this;
    _classCallCheck(this, SecretMintingDialog);
    _this = _callSuper(this, SecretMintingDialog, [props]);
    _this.state = {
      modalOpen: false,
      saveAPIKeyOptions: {
        name: "",
        description: "",
        saveKeyChecked: false,
        hasError: false,
        provider: "",
        region: "",
        resource_group: "",
        resource_group_name: "",
        instance: "",
        group: "",
        secret: ""
        // Note, toolcardName, reference not saved here:
        // toolcardName: "",
        // reference: ""
      },
      cumulativeState: "idle",
      noIntegrations: false
    };
    _this.createButton = /*#__PURE__*/React.createRef();
    autoBind(_this);
    return _this;
  }
  _inherits(SecretMintingDialog, _Component);
  return _createClass(SecretMintingDialog, [{
    key: "onCreateClicked",
    value: function onCreateClicked(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var defaultName = "";
      var defaultDescription = "";
      if (this.props.keyCreationType === "gpg-key") {
        var _this$props$userInfo;
        defaultName = this.props.toolchainName || "";
        defaultDescription = ((_this$props$userInfo = this.props.userInfo) === null || _this$props$userInfo === void 0 ? void 0 : _this$props$userInfo.email) || "";
      } else {
        defaultName = this.geti18nText("defaultName");
        defaultName = format(defaultName, [this.props.toolchainName]).slice(0, 50);
      }
      this.setState(function (prevState) {
        return {
          modalOpen: true,
          saveAPIKeyOptions: _objectSpread(_objectSpread({}, prevState.saveAPIKeyOptions), {}, {
            saveKeyChecked: false,
            secret: "",
            group: "",
            instance: "",
            name: defaultName,
            description: defaultDescription
          })
        };
      });
      this.props.onModalEvent && this.props.onModalEvent(true);
    }
  }, {
    key: "onCreateAPIKeyModalClose",
    value: function onCreateAPIKeyModalClose(evt) {
      if (evt.type === "click" && evt.target && evt.target.className && typeof evt.target.className === "string" && evt.target.className.includes("apiKeyCreateModal")) {
        // Ignore mouse click events on the overlay outside of the dialog
        return;
      }
      this.setState({
        modalOpen: false
      });
      this.props.onModalEvent && this.props.onModalEvent(false);
    }
  }, {
    key: "onCreateAPIKeyModalSubmit",
    value: function onCreateAPIKeyModalSubmit(evt) {
      this.onCreateAPIKeyModalClose(evt);
      var _metadata = _objectSpread(_objectSpread({}, this.state.saveAPIKeyOptions), {}, {
        toolcard: false
      });
      if (this.props.vaultEnabled && this.state.saveAPIKeyOptions.saveKeyChecked) {
        if (_metadata.provider === vaultUtil.KP_PROVIDER_TYPE) {
          _metadata.reference = "{".concat(vaultUtil.KP_REFERENCE_TYPE, "::") + "".concat(_metadata.region, ".") + "".concat(_metadata.resource_group_name, ".") + "".concat(_metadata.instance, ".") + "".concat(_metadata.secret, "}");
          _metadata.toolcard = false;
        } else if (_metadata.provider === vaultUtil.SM_PROVIDER_TYPE) {
          _metadata.reference = "{".concat(vaultUtil.SM_REFERENCE_TYPE, "::") + "".concat(_metadata.region, ".") + "".concat(_metadata.resource_group_name, ".") + "".concat(_metadata.instance, ".") + "".concat(_metadata.group, ".") + "".concat(_metadata.secret, "}");
          _metadata.toolcard = false;
        } else if (_metadata.provider.startsWith("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.KP_PROVIDER_TYPE, ":"))) {
          var toolcardName = _metadata.provider.substring("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.KP_PROVIDER_TYPE, ":").length);
          _metadata.reference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(toolcardName, ".").concat(_metadata.secret, "}");
          _metadata.toolcard = true;
        } else if (_metadata.provider.startsWith("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.HV_PROVIDER_TYPE, ":"))) {
          var _toolcardName = _metadata.provider.substring("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.HV_PROVIDER_TYPE, ":").length);
          if (this.state.saveAPIKeyOptions.subdir && this.state.saveAPIKeyOptions.subdir.length > 0 && this.state.saveAPIKeyOptions.basePath && this.state.saveAPIKeyOptions.subdir.startsWith(this.state.saveAPIKeyOptions.basePath)) {
            var _subdir_path = this.state.saveAPIKeyOptions.subdir.substring(this.state.saveAPIKeyOptions.basePath.length + 1);
            if (_subdir_path.length > 0 && !_subdir_path.endsWith("/")) {
              _subdir_path += "/";
            }
            _metadata.reference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(_toolcardName, ".").concat(_subdir_path).concat(_metadata.group).concat(_metadata.secret ? ".".concat(_metadata.secret) : "", "}");
          } else {
            _metadata.reference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(_toolcardName, ".").concat(_metadata.group).concat(_metadata.secret ? ".".concat(_metadata.secret) : "", "}");
          }
          _metadata.toolcard = true;
        } else if (_metadata.provider.startsWith("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.SM_PROVIDER_TYPE, ":"))) {
          var _toolcardName2 = _metadata.provider.substring("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.SM_PROVIDER_TYPE, ":").length);
          _metadata.reference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(_toolcardName2, ".").concat(_metadata.group, ".").concat(_metadata.secret, "}");
          _metadata.toolcard = true;
        }
      }

      // Create the key
      this.props.onCreateAPIKey(evt, undefined, _metadata);
    }
  }, {
    key: "onSaveKeyCheckboxChanged",
    value: function onSaveKeyCheckboxChanged(checked) {
      this.setState(function (prevState) {
        return {
          saveAPIKeyOptions: _objectSpread(_objectSpread({}, prevState.saveAPIKeyOptions), {}, {
            saveKeyChecked: checked
          })
        };
      });
    }
  }, {
    key: "onFieldChange",
    value: function onFieldChange(fieldname, newValue, hasError, callback) {
      if (callback && typeof callback === "function") {
        this.setState(function (prevState) {
          return {
            saveAPIKeyOptions: _objectSpread(_objectSpread({}, prevState.saveAPIKeyOptions), {}, _defineProperty(_defineProperty({}, fieldname, newValue), "hasError", hasError))
          };
        }, callback);
      } else {
        this.setState(function (prevState) {
          return {
            saveAPIKeyOptions: _objectSpread(_objectSpread({}, prevState.saveAPIKeyOptions), {}, _defineProperty(_defineProperty({}, fieldname, newValue), "hasError", hasError))
          };
        });
      }
    }
  }, {
    key: "onMultipleFieldsChange",
    value: function onMultipleFieldsChange(fieldNameValuePairs) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$hasError = _ref.hasError,
        hasError = _ref$hasError === void 0 ? false : _ref$hasError,
        callback = _ref.callback;
      var usedCallback = callback && typeof callback === "function" ? callback : undefined;
      this.setState(function (prevState) {
        return {
          saveAPIKeyOptions: _objectSpread(_objectSpread(_objectSpread({}, prevState.saveAPIKeyOptions), fieldNameValuePairs), {}, {
            hasError: hasError
          })
        };
      }, usedCallback);
    }
  }, {
    key: "onCumulativeStateChange",
    value: function onCumulativeStateChange(cumulativeState) {
      this.setState({
        cumulativeState: cumulativeState
      });
    }
  }, {
    key: "geti18nText",
    value: function geti18nText(id) {
      var key = keyTypeText[this.props.keyCreationType] && keyTypeText[this.props.keyCreationType][id];
      if (key) {
        return this.props.i18n.messages[key] || "";
      }
      return "";
    }
  }, {
    key: "updateModalState",
    value: function updateModalState(newState) {
      this.setState(newState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var i18nStrings = this.props.i18n.messages;
      var _this$state = this.state,
        modalOpen = _this$state.modalOpen,
        saveAPIKeyOptions = _this$state.saveAPIKeyOptions,
        cumulativeState = _this$state.cumulativeState;
      var keyCreationType = this.props.keyCreationType;
      var props = {
        open: modalOpen,
        primaryButtonText: i18nStrings.ok,
        primaryButtonDisabled: !saveAPIKeyOptions.name || !saveAPIKeyOptions.description && keyCreationType === "gpg-key" || saveAPIKeyOptions.saveKeyChecked && (cumulativeState === "fetching" || saveAPIKeyOptions.hasError),
        secondaryButtonText: i18nStrings.cancel,
        modalHeading: this.geti18nText("modalHeading"),
        modalAriaLabel: this.geti18nText("modalHeading"),
        onRequestClose: this.onCreateAPIKeyModalClose,
        onRequestSubmit: this.onCreateAPIKeyModalSubmit
      };
      var UIprops = _objectSpread(_objectSpread(_objectSpread({}, this.props), saveAPIKeyOptions), {}, {
        onFieldChange: this.onFieldChange,
        onMultipleFieldsChange: this.onMultipleFieldsChange,
        onCumulativeStateChange: this.onCumulativeStateChange,
        mode: "save",
        modalOpen: modalOpen,
        updateModalState: this.updateModalState,
        noIntegrations: this.state.noIntegrations
      });
      var saveKeyChecked = saveAPIKeyOptions.saveKeyChecked;
      var toolTip = this.props.accountType === "STANDARD" ? i18nStrings.billableAccountRequired : undefined;
      var idPrefix = this.props.idPrefix ? "".concat(this.props.idPrefix, "-") : "";
      var buttonTooptip = this.geti18nText("buttonTooptip");
      var createBtnAnalyticsLabel = this.props.analyticsPrefix ? "".concat(this.props.analyticsPrefix, "-create-api-key-btn") : null;
      return /*#__PURE__*/React.createElement(IntlProvider, {
        locale: this.props.i18n.locale,
        messages: i18nStrings
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--create-button-container"
      }, /*#__PURE__*/React.createElement(Button, {
        "aria-label": buttonTooptip,
        className: "ocr--new-button",
        "data-analytics-track": createBtnAnalyticsLabel,
        onClick: this.onCreateClicked,
        ref: this.createButton,
        renderIcon: Add,
        size: "md",
        title: buttonTooptip,
        type: "button"
      }, i18nStrings["new"]), /*#__PURE__*/React.createElement(Modal, _extends({}, props, {
        hasForm: true,
        className: "ocr--api-key-mint-modal"
      }), /*#__PURE__*/React.createElement("div", {
        className: "ocr--modal-description"
      }, /*#__PURE__*/React.createElement(FormattedHTMLMessage, {
        id: this.geti18nText("modalDescription")
      }), this.props.showWarning === true ? /*#__PURE__*/React.createElement("div", {
        className: "ocr--warning-container"
      }, /*#__PURE__*/React.createElement(WarningAlt, {
        className: "ocr--warning-icon",
        size: "20"
      }), /*#__PURE__*/React.createElement(FormattedHTMLMessage, {
        id: "createAPIKeyWarning"
      })) : null), /*#__PURE__*/React.createElement("div", {
        className: "ocr--modal-split-row-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--modal-form-section-container ocr--api-key-input"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--form-item"
      }, /*#__PURE__*/React.createElement("label", {
        className: "cds--label",
        htmlFor: "".concat(idPrefix, "api-key-name-id")
      }, i18nStrings.newKeyName), /*#__PURE__*/React.createElement("input", _extends({
        id: "".concat(idPrefix, "api-key-name-id"),
        "aria-label": i18nStrings.newKeyName,
        className: "cds--text-input",
        value: saveAPIKeyOptions.name,
        onChange: function onChange(e) {
          return _this2.onFieldChange("name", e.target.value, saveAPIKeyOptions.hasError);
        },
        type: "text"
      }, !saveAPIKeyOptions.name ? {
        "data-invalid": true
      } : {})), /*#__PURE__*/React.createElement("div", {
        className: "cds--form-requirement"
      }, !saveAPIKeyOptions.name ? i18nStrings.requiredFieldError : null))), /*#__PURE__*/React.createElement("div", {
        className: "ocr--modal-form-section-container ocr--description-input"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--form-item"
      }, /*#__PURE__*/React.createElement("label", {
        className: "cds--label",
        htmlFor: "".concat(idPrefix, "api-key-description-id")
      }, this.geti18nText("descriptionLabel")), /*#__PURE__*/React.createElement("input", _extends({
        id: "".concat(idPrefix, "api-key-description-id"),
        "aria-label": this.geti18nText("descriptionLabel"),
        className: "cds--text-input",
        value: saveAPIKeyOptions.description,
        onChange: function onChange(e) {
          return _this2.onFieldChange("description", e.target.value, saveAPIKeyOptions.hasError);
        },
        type: "text"
      }, !saveAPIKeyOptions.description && keyCreationType === "gpg-key" ? {
        "data-invalid": true
      } : {})), /*#__PURE__*/React.createElement("div", {
        className: "cds--form-requirement"
      }, !saveAPIKeyOptions.description && keyCreationType === "gpg-key" ? i18nStrings.requiredFieldError : null)))), this.props.vaultEnabled ? /*#__PURE__*/React.createElement(Checkbox, {
        labelText: i18nStrings.saveKey,
        id: "".concat(idPrefix, "SaveAPIKey"),
        onChange: this.onSaveKeyCheckboxChanged,
        checked: saveKeyChecked,
        disabled: this.props.accountType === "STANDARD",
        title: toolTip
      }) : null, /*#__PURE__*/React.createElement(SecretDialogFields, _extends({
        id: "".concat(idPrefix, "secret-dialog-fields-save")
      }, UIprops, {
        className: saveKeyChecked ? "" : "ocr--hidden"
      })))));
    }
  }]);
}(Component);
SecretMintingDialog.propTypes = {
  toolchainName: PropTypes.string.isRequired,
  onCreateAPIKey: PropTypes.func.isRequired,
  onModalEvent: PropTypes.func,
  vaultEnabled: PropTypes.bool,
  idPrefix: PropTypes.string,
  accountType: PropTypes.string,
  keyCreationType: PropTypes.string,
  showWarning: PropTypes.bool,
  secretInputName: PropTypes.string,
  i18n: PropTypes.object.isRequired,
  mock: PropTypes.bool,
  userInfo: PropTypes.object
};
SecretMintingDialog.defaultProps = {
  vaultEnabled: false,
  idPrefix: "",
  mock: false,
  accountType: "UNKNOWN"
};
export default SecretMintingDialog;